import { requestBuilder } from '../../http/RequestBuilder';
import type { GeneralResponse } from '../../http/types/Common';
import type { Provider } from '../types/HolisticSummary';

interface UseRenameAccountBody {
    accountId: string;
    name: string;
    provider: Provider;
}

const useRenameAccount = requestBuilder.mutation<
    GeneralResponse,
    UseRenameAccountBody
>({
    endpoint: '/api/holistic/rename',
    method: 'PATCH',
});

export default useRenameAccount;
